import React, { Component } from "react";
import { connect } from "react-redux";
import * as searchActions from "../../../_actions/searchActions";
import Wrapper from "../../../_hoc/Wrapper";
import Section from "../../UI/Section";
import Filter from "./Filter";
import Results from "./Results";
class Normal extends Component {
  componentDidMount() {
    const { updateHeader, updateBreadcrumb } = this.props;
    updateHeader({
      title: "Advance Search",
      description: "Place to find your special one"
    });
    updateBreadcrumb([
      { label: "Home", link: "/" },
      { label: "Search", link: "/search" },
      { label: "Advance", link: "/search/normal" }
    ]);
  }
  componentWillUnmount() {
    const { clear } = this.props;
    clear();
  }
  render() {
    return (
      <Wrapper>
        <Section white>
          <Filter />
        </Section>
        <Section>
          <Results />
        </Section>
      </Wrapper>
    );
  }
}
const mapDispatchToProps = dispatch => ({
  clear: () => dispatch(searchActions.clearSearchResults())
});

export default connect(
  null,
  mapDispatchToProps
)(Normal);



// WEBPACK FOOTER //
// ./src/_components/Search/Advance/index.js